import { render, staticRenderFns } from "./QuizModal.vue?vue&type=template&id=3e9cda16&scoped=true&"
import script from "./QuizModal.vue?vue&type=script&lang=ts&"
export * from "./QuizModal.vue?vue&type=script&lang=ts&"
import style0 from "./QuizModal.vue?vue&type=style&index=0&id=3e9cda16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9cda16",
  null
  
)

export default component.exports